/**
 * Validate screen size
 * @param {string} query - Queries how css, ex: '(min-with: 992px)'
 * @param {function} cb - Callback to run if is math with screen size
 * @author Daniel Santos
 */
export const mediaQuery = (query, cb) => {
  const mql = window.matchMedia(query);

  if (mql.matches) {
    cb();
  }
}
